{
  "meta": {
    "home": {
      "title": "BYHOURS: Reserva en más de 4.000 hoteles por horas",
      "description": "Reserva habitaciones por horas en tu hotel favorito y decide la hora de check-in. Escoge entre más de 4.000 hoteles de 3, 4 y 5 estrellas y reserva en más de 25 países. Accede a todos los servicios del Hotel con cancelación gratuita. Reserva ya con BYHOURS, líder en Microestancias.",
      "keywords": "Hoteles por horas, hotel por horas, horas de hotel, byhours, byhours.com, habitaciones por horas, hoteles por horas en Barcelona, hoteles por horas en Madrid, hoteles por horas en Sevilla, hoteles por horas en Valencia, hoteles por horas en Bilbao, micro-estancia, microestancia, by hours, microestancias, horas de hotel, hotel a horas, hotel de día, hotel para parejas, hotel parejas, hotel económico, hotel para trabajar, hotel aeropuerto, habitaciones de día, dayuse, daybreak, hotel por horas para trabajar, hotel por horas cerca aeropuerto, hotel para descansar aeropuerto, hotel aeropuerto, hotel por horas aeropuerto, hotel de paso, hotel cerca de la estación de tren, habitación de día, habitaciones durante el día, byhours"
    },
    "search": {
      "title": "Hoteles por horas en {city_name}",
      "description": "Los mejores hoteles de {city_name} disponibles por horas en paquetes de 3, 6 y 24 horas. Para uso diurno y nocturno con acceso a todas las instalaciones del hotel. Cancelación gratuita y check-in flexible.",
      "keywords": "byhours, hoteles por horas en {city_name}, buyhours, horas de hotel en {city_name}, reservar por horas en {city_name}, hoteles {city_name}, microestancias {city_name}, habitaciones por horas {city_name}, reserva de hoteles por horas {city_name}, hotel de día {city_name}, {city_name}, byhours {city_name}, habitación de día en {city_name}, habitación por unas horas de día en {city_name}, microestancias en {city_name}"
    },
    "detail": {
      "title": "{hotel_name} {city_name} por 3, 6 o 24 horas",
      "description": "Disfruta de unas horas de desconexión en {hotel_name} en {city_name} y paga solo por el tiempo que necesitas. Elige la hora de entrada que más te convenga y disfruta de todas las instalaciones como el spa, la piscina o el restaurante. {hotel_description}",
      "keywords": "byhours {hotel_name}, by hours {hotel_name}, buyhours {hotel_name}, {hotel_name}, horas de hotel {hotel_name}, hotel por horas {hotel_name}, hoteles por horas {city_name}, reservar por horas en {hotel_name}, hoteles {city_name}, microestancias {hotel_name}, habitaciones por horas {hotel_name}, reserva de hoteles por horas {city_name}, hotel de día {hotel_name}, reserva habitaciones por horas {hotel_name}"
    },
    "landing": {
      "title": "Hoteles por horas en {city_name}",
      "description": "Los mejores hoteles de {city_name} disponibles por horas en paquetes de 3, 6 y 24 horas. Para uso diurno y nocturno con acceso a todas las instalaciones del hotel. Cancelación gratuita y check-in flexible.",
      "keywords": "byhours, hoteles por horas en {city_name}, buyhours, horas de hotel en {city_name}, reservar por horas en {city_name}, hoteles {city_name}, microestancias {city_name}, habitaciones por horas {city_name}, reserva de hoteles por horas {city_name}, hotel de día {city_name}, {city_name}, byhours {city_name}, habitación de día en {city_name}, habitación por unas horas de día en {city_name}, microestancias en {city_name}"
    },
    "como-funciona": {
      "title": "Cómo reservar hoteles por horas: paso a paso",
      "description": "Descubre cómo en tan solo 4 sencillos pasos puedes disfrutar de 3, 6 ó 24 horas de hotel en más de 600 destinos.",
      "keywords": "dudas, pasos, como reservar, byhours, hoteles por horas"
    },
    "byhours-destinations": {
      "title": "Reserva en más de 600 destinos",
      "description": "Reserva habitaciones por horas en tu hotel favorito y decide la hora de check-in. Escoge entre más de 4.000 hoteles de 3, 4 y 5 estrellas y reserva en más de 600 destinos. Accede a todos los servicios del Hotel con cancelación gratuita. Reserva ya con BYHOURS, líder en Microestancias.",
      "keywords": "hoteles, destinos, byhours"
    },
    "privacy": {
      "title": "Política de privacidad",
      "description": "Política de privacidad y protección de datos de BYHOURS. Información sobre el tratamiento de tus datos personales al usar nuestros servicios de reserva de hoteles por horas."
    },
    "terms": {
      "title": "Términos y condiciones",
      "description": "Términos y condiciones de uso del servicio BYHOURS. Condiciones para reservar habitaciones por horas en más de 4.000 hoteles."
    },
    "onDemand": {
      "title": "BYHOURS On Demand — Solicitud de disponibilidad",
      "description": "Cuéntanos qué necesitas y nuestro equipo te ayudará a encontrar disponibilidad bajo petición."
    },
    "hoteliers": {
      "title": "BYHOURS para hoteleros — Convierte horas vacías en ingreso",
      "description": "Vende microestancias en franjas de 3, 6 y 24 horas con tus reglas: precio, disponibilidad y canal propio. Sin cupo mínimo.",
      "ogTitle": "BYHOURS para hoteleros",
      "ogDescription": "Monetiza inventario ocioso con microestancias y control total desde la extranet."
    }
  },
  "stickyBookingBar": {
    "reservarAhora": "Reservar ahora",
    "elegirHora": "Elegir hora",
    "aria": "Barra de reserva rápida"
  },
  "roomCard": {
    "badges": {
      "freeCancellation": "Cancelación gratis hasta 24h",
      "payNow": "Pagar ahora",
      "payAtDestination": "Pago en destino"
    },
    "packWindow": {
      "allDay": "Todo el día"
    },
    "packOption": {
      "hours": "{count} horas",
      "vatIncluded": "IVA incluido",
      "availabilityTitle": "Disponibilidad",
      "extraHourPromo": "Incluye 1h extra de estancia"
    },
    "realPrice": {
      "taxesIncluded": "Impuestos y tasas incluidos",
      "taxesNotIncluded": "Impuestos y tasas no incluidos",
      "taxesBreakdown": "Desglose de impuestos y tasas"
    },
    "reserve": "Reservar"
  },
  "searchCard": {
    "urgency": {
      "oneRoom": "Queda 1 habitación",
      "moreRooms": "Quedan {count} habitaciones"
    },
    "viewRooms": "Ver habitaciones",
    "availablePacks": {
      "one": "Estancia de {pack}h",
      "many": "Estancias {packs}"
    },
    "promos": {
      "multiple": "{count} promociones",
      "modalTitle": "Promociones disponibles"
    }
  },
  "buttons": {
    "borrar": "Borrar",
    "reiniciar": "Reiniciar",
    "aplicar": "Aplicar",
    "cerrar": "Cerrar",
    "filtros": "Filtros",
    "buscar": "Buscar",
    "cargando": "Cargando",
    "mapa": "Mapa global",
    "buscarZona": "Buscar en esta zona",
    "filtroEntrada": "Hora entrada",
    "eligeHorario": "Elige tu horario",
    "continuar": "Continuar",
    "continuarSinExtras": "Continuar sin extras",
    "cancel": "Cancelar",
    "buscarDia": "Buscar otro día",
    "buscarOtroHotel": "Buscar otro hotel",
    "noDispo": "No disponible",
    "dispo": "Hora de entrada",
    "dispoOtrosDias": "Disponible otros días",
    "moreImg": "Más imágenes",
    "readMore": "Leer más",
    "readLess": "Leer menos",
    "reservar": "Reservar",
    "cancelBook": "Cancelar reserva",
    "modifyBook": "Modificar reserva",
    "repeatBook": "Repetir reserva",
    "deleteBook": "Borrar reserva",
    "clearHistory": "Borrar historial",
    "desde": "Desde",
    "todos": "Todos",
    "login": "Iniciar sesión",
    "verMapa": "Ver mapa",
    "compartir": "Compartir",
    "guardar": "Guardar",
    "guardado": "Guardado"
  },
  "labels": {
    "hoy": "Hoy",
    "mañana": "Mañana",
    "dia": "día",
    "dateRangeShortMinus1": "- 1 día",
    "dateRangeShortPlus1": "+ 1 día",
    "dateRangeShortBoth": "± 1 día",
    "dateRangeMinus1": "Buscar un día antes",
    "dateRangePlus1": "Buscar un día después",
    "dateRangeBoth": "Buscar un día antes y después",
    "dateRangeSelector": "Ampliar búsqueda a días cercanos",
    "horas": "horas",
    "hoteles": "hoteles",
    "todoDia": "Todo el día",
    "searchDestino": "Destinos que coinciden con",
    "destinosPopulares": "Destinos populares",
    "busquedasRecientes": "Últimas búsquedas",
    "placeholderDestino": "Busca el destino...",
    "ubicacion": "Ubicación",
    "rooms": "Habitaciones",
    "pack": "Pack horas",
    "entrada": "Entrada",
    "horarioReserva": "Horario de reserva",
    "salida": "Salida",
    "nombre": "Nombre",
    "apellido": "Apellido",
    "ciudad": "Ciudad",
    "telefono": "Teléfono",
    "extras": "Extras reservados",
    "password": "Contraseña actual",
    "newPassword": "Nueva contraseña",
    "repeatPassword": "Repetir nueva contraseña",
    "passwordRequirements": {
      "length": "Al menos 8 caracteres",
      "uppercase": "Al menos 1 letra mayúscula",
      "lowercase": "Al menos 1 letra minúscula",
      "number": "Al menos 1 número"
    },
    "email": "Email",
    "detalle": "Detalles",
    "pago": "Datos de pago",
    "pagado": "Pagado",
    "total": "Total",
    "changePassword": "Cambiar contraseña",
    "precioHab": "por habitación",
    "errorHora": "Elige tu hora de entrada",
    "errorHotel": "No hemos encontrado el hotel",
    "errorDestino": "No se ha encontrado el destino",
    "errorPaginaNoEncontrada": "Página no encontrada",
    "errorPaginaNoEncontradaSubtitle": "La página que buscas no existe.",
    "verHoteles": "Ver hoteles en {city_name}",
    "verHotelesDisponibles": "Ver los {count} hoteles disponibles en {city_name}",
    "destacados": "Hoteles destacados en {city_name}",
    "reserva": "Encuentra tu hotel por horas",
    "descubre": "Descubre hoteles en {city_name}",
    "comoFunciona": "¿Cómo funciona?",
    "errorResultado": "Upps... No encontramos nada que coincida con tu búsqueda.",
    "errorResultadoTitle": "Sin resultados",
    "destinos": "Destinos",
    "selectDestino": "Selecciona un país",
    "ubicacionActual": "Ubicación actual",
    "zonaActual": "Zona seleccionada",
    "selectCity": "Selecciona una ciudad",
    "sinDisponibilidadTitle": "Sin disponibilidad por el momento",
    "sinDisponibilidadDescription": "Actualmente no hay hoteles disponibles en este destino. Te invitamos a volver más tarde o explorar otras opciones.",
    "buscarOtroDestino": "Buscar otro destino",
    "buscarOtraUbicacion": "Buscar otra ubicación",
    "numRooms": "Nº habitaciones",
    "hero": {
      "entradaFlexible": "Entrada flexible",
      "hotelesVerificados": "Hoteles verificados",
      "sinNocheMinima": "Sin noche mínima"
    },
    "ariaLabelHorarioFlexible": "Información horario flexible",
    "aria": {
      "home": "Inicio",
      "idiomaMoneda": "Idioma y moneda",
      "usuario": "Usuario",
      "menu": "Menú",
      "favorito": "Favorito",
      "compartir": "Compartir",
      "info": "Información",
      "diaAnterior": "Día anterior",
      "diaSiguiente": "Día siguiente",
      "descargarAppIos": "Descargar aplicación para iOS",
      "descargarAppAndroid": "Descargar aplicación para Android",
      "showPassword": "Mostrar contraseña",
      "hidePassword": "Ocultar contraseña"
    },
    "login": {
      "title": "Te damos la bienvenida a BYHOURS",
      "password": "¿Has olvidado tu contraseña?",
      "session": "Iniciar sesión",
      "noAccount": "¿No tienes una cuenta?",
      "registerLabel": "Regístrate",
      "placeholder": {
        "email": "Dirección de correo electrónico *",
        "password": "Contraseña *"
      },
      "continue": "Continuar",
      "o": "O",
      "recover": {
        "title": "Recupera tu contraseña",
        "subtitle": "Escribe tu dirección de correo electrónico y te enviaremos las instrucciones para restablecer la contraseña.",
        "subtitle2": "Escribe tu nueva contraseña y la confirmación de la nueva contraseña.",
        "back": "Volver a iniciar sesión"
      },
      "register": {
        "title": "Crea tu cuenta en BYHOURS",
        "account": "¿Ya tienes una cuenta?"
      },
      "google": "Continuar con Google",
      "facebook": "Continuar con Facebook",
      "footer": {
        "user": "Acuerdo de usuario",
        "privacy": "Política de privacidad",
        "cookies": "Política de cookies"
      },
      "emailConfirmation": {
        "title": "Confirma tu correo electrónico!",
        "subtitle": "Hemos enviado un correo electrónico a {email} con un enlace para confirmar tu dirección de correo electrónico. Si no lo ves en tu bandeja de entrada, revisa la carpeta de spam.",
        "resend": "Reenviar correo electrónico"
      },
      "dropdown": {
        "perfil": "Perfil",
        "cerrar": "Cerrar sesión"
      }
    },
    "proximaReserva": {
      "titulo": "Próxima reserva",
      "ver": "Ver reserva",
      "repetir": "Repetir reserva",
      "repetirSubtitulo": "Hace {days} días",
      "repetirSubtituloHoy": "Reservaste hoy",
      "repetirSubtituloAyer": "Reservaste ayer",
      "repetirDescripcion": "Reservaste hace {days} días en {hotel}",
      "repetirDescripcionHoy": "Reservaste hoy en {hotel}",
      "repetirDescripcionAyer": "Reservaste ayer en {hotel}"
    },
    "user_zone": {
      "emailVerified": {
        "title": "Email verificado",
        "description": "Ya puedes usar la zona de usuario con normalidad."
      },
      "menu": {
        "perfil": "Perfil",
        "reservas": "Mis reservas",
        "favoritos": "Favoritos",
        "inicio": "Inicio BYHOURS",
        "cerrarSesion": "Cerrar sesión"
      },
      "favoritos": {
        "noFavoritosTitle": "Todavía no tienes favoritos",
        "noFavoritosSubtitle": "¿A qué esperas? Marca tus hoteles favoritos",
        "completeProfile": "Debes completar tu perfil para poder añadir hoteles a favoritos"
      },
      "perfil": {
        "danger": "Danger zone",
        "deleteAccount": "Eliminar cuenta",
        "deleteAccountText": "¿Estás seguro de que deseas eliminar tu cuenta?",
        "deleteAccountText2": "Esta acción es permanente y no se puede deshacer. Todos tus datos se eliminarán de forma definitiva.",
        "successUpdate": "Se ha actualizado la información correctamente",
        "successDelete": "Se ha eliminado el usuario correctamente"
      },
      "reservas": {
        "noReservasTitle": "Todavía no tienes reservas",
        "noReservasSubtitle": "¿A qué esperas? Reserva tu habitación con nosotros",
        "activas": "Activas",
        "pasadas": "Pasadas",
        "cancelled": "Cancelada",
        "cancel": "Reserva cancelada correctamente",
        "cancelError": "Error al cancelar la reserva",
        "reference": "Localizador",
        "price": "Precio",
        "cancelText": "¿Estás seguro de que desea cancelar la reserva?",
        "cancelText2": "Si cancelas ahora, podrías perder tu reserva actual.",
        "deleteText": "¿Estás seguro de que deseas borrar esta reserva?",
        "deleteText2": "Esta acción es permanente y no podrás recuperar la reserva.",
        "deleteSuccess": "Reserva borrada correctamente",
        "deleteError": "Error al borrar la reserva",
        "clearHistoryText": "¿Estás seguro de que deseas borrar todo el historial?",
        "clearHistoryText2": "Todas tus reservas pasadas se ocultarán permanentemente.",
        "clearHistorySuccess": "Historial borrado correctamente",
        "clearHistoryError": "Error al borrar el historial",
        "detalle": {
          "titulo": "Detalles de la reserva",
          "tiempo": "Tiempo de estancia"
        }
      }
    },
    "cancelBook": {
      "title": "Cancelar reserva",
      "subtitle": "Introduce el localizador de la reserva y el email con el que la realizaste. Solo podrás cancelar si cumples la política de cancelación (por ejemplo, con al menos 24h de antelación al check-in).",
      "referenceError": "Introduce el localizador de la reserva",
      "referencePlaceholder": "Localizador",
      "emailPlaceholder": "Email",
      "submit": "Cancelar reserva",
      "success": "La reserva se ha cancelado correctamente",
      "genericError": "No se pudo cancelar la reserva",
      "backHome": "Volver al inicio"
    },
    "tags": {
      "piscina": "¡Disfruta de acceso a la piscina incluido con tu reserva! 💦"
    },
    "tooltips": {
      "packHours": "Puedes reservar {hours}h dentro de esta franja",
      "horarioFlexible": "Tu entrada es flexible dentro del horario mostrado, pero la salida debe ser puntual."
    },
    "extraHours": {
      "maxExtraHours": "Puede añadirse un máximo de {hours} horas extra",
      "noExtraHours": "No se pueden añadir horas extra a la hora seleccionada"
    },
    "horasDisponibles": "Horas disponibles",
    "gratis": "Gratis"
  },
  "errors": {
    "search": "Ha ocurrido un error al buscar hoteles. Por favor, inténtalo de nuevo.",
    "ubicacion": {
      "support": "Parece que tu navegador no admite la función de geolocalización. Prueba con otro navegador o activa la opción en la configuración.",
      "block": "La ubicación está bloqueada en tu navegador. Para activarla, ve a la configuración y permite el acceso a la ubicación.",
      "permission": "No pudimos acceder a tu ubicación porque denegaste el permiso. Puedes activarlo en la configuración de tu dispositivo.",
      "gps": "No hemos podido determinar tu ubicación. Asegúrate de tener el GPS activado y una conexión estable.",
      "timeout": "La solicitud de ubicación está tardando más de lo esperado. Inténtalo de nuevo en unos momentos.",
      "error": "Ha ocurrido un error al intentar obtener tu ubicación. Por favor, inténtalo de nuevo."
    },
    "login": {
      "email": "Email no válido",
      "password": "Al menos 8 caracteres",
      "passwordComplexity": "Debe contener al menos una letra mayúscula, una letra minúscula y un número",
      "repeatPassword": "Las contraseñas no coinciden",
      "emailDomain": "El dominio del correo no parece válido",
      "facebook_email_required": "Facebook no compartió tu email con nosotros. Para hacer login con Facebook en BYHOURS, ve a tu configuración de aplicaciones de Facebook y otorga el permiso de email a BYHOURS."
    },
    "user_zone": {
      "delete": "Error al eliminar el usuario",
      "password": "Error al cambiar la contraseña"
    }
  },
  "share": {
    "copy": "Copiar enlace",
    "whatsapp": "Compartir en WhatsApp",
    "email": "Compartir por correo",
    "message": "¡Hola! Te comparto este hotel que me pareció interesante: {url}"
  },
  "checkout": {
    "meta": {
      "title": "Checkout",
      "description": "Completa tu reserva"
    },
    "timer": "Tu habitación está reservada durante {time} minutos",
    "steps": {
      "checkinHour": "Hora de entrada",
      "data": "Tus datos",
      "payment": "Pago seguro",
      "back": "Volver"
    },
    "sections": {
      "completeCheckinHour": "Selecciona la hora de entrada para continuar"
    },
    "checkinHour": {
      "title": "Hora de entrada",
      "subtitle": "Elige a qué hora quieres entrar",
      "required": "Selecciona una hora de entrada para continuar",
      "pendingSummary": "Selecciona tu hora de entrada",
      "description": "Elige tu hora de entrada dentro de {window}; desde esa hora disfrutarás de {hours} horas de estancia.",
      "descriptionNoWindow": "Elige tu hora de entrada; desde esa hora disfrutarás de {hours} horas de estancia.",
      "placeholder": "Elige tu hora de entrada",
      "changeHour": "Cambiar hora",
      "descriptionSelected": "Entrada flexible a partir de las {checkin}. Tienes la habitación disponible de {checkin} a {checkout}."
    },
    "extras": {
      "title": "Extras",
      "continueWithout": "Continuar sin extras",
      "noneForHour": "No hay extras disponibles para la hora seleccionada"
    },
    "recovery": {
      "title": "Tienes una reserva en curso",
      "finishBooking": "Finalizar mi reserva",
      "closeAria": "Cerrar aviso de reserva"
    },
    "contactData": {
      "title": "Datos de contacto",
      "loginPrompt": "¿Ya tienes cuenta?",
      "loginButton": "Inicia sesión",
      "registerButton": "Regístrate",
      "loginPromptSuffix": "para agilizar tus próximas reservas.",
      "continueAsGuest": "Continuar como invitado",
      "firstName": "Nombre",
      "firstNamePlaceholder": "Laura",
      "lastName": "Apellidos",
      "lastNamePlaceholder": "García",
      "email": "Email",
      "emailPlaceholder": "laura.garcia{'@'}byhours.com",
      "phone": "Teléfono",
      "phonePlaceholder": "612 345 678",
      "city": "Ciudad",
      "cityPlaceholder": "Madrid"
    },
    "promoCode": {
      "title": "Código promocional",
      "placeholder": "Ejemplo: VERANO10",
      "apply": "Aplicar",
      "applied": "Código promocional aplicado",
      "remove": "Eliminar",
      "errors": {
        "required": "Introduce un código promocional válido",
        "invalid": "Código promocional no válido",
        "generic": "Error al aplicar el código promocional"
      }
    },
    "comments": {
      "title": "Comentarios para el hotel",
      "placeholder": "Ejemplo: 'Necesito una habitación adaptada para silla de ruedas'"
    },
    "payment": {
      "title": "Método de pago"
    },
    "trustBadges": {
      "securePayment": "Pago seguro (Stripe)",
      "freeCancellation": "Cancelación gratuita",
      "encryptedData": "Datos cifrados"
    },
    "terms": {
      "text": "Al reservar estás aceptando nuestro",
      "userAgreement": "Acuerdo de Usuario",
      "privacyText": "En BYHOURS trataremos tus datos personales para gestionar tu reserva y mantenerte informado durante todo el proceso.",
      "privacyInfo": "Para más información consulta nuestra",
      "privacyPolicy": "Política de Privacidad"
    },
    "buttons": {
      "continue": "Continuar",
      "confirmAndPay": "Confirmar y pagar ahora",
      "payNow": "Pagar ahora"
    },
    "loading": "Procesando pago...",
    "summary": {
      "hotel": "Hotel",
      "address": "Dirección",
      "checkIn": "Entrada",
      "checkOut": "Salida",
      "hotelTaxes": "Tasas e impuestos del hotel",
      "hotelTaxesTooltip": "En función del destino, es posible que algunas tasas y/o impuestos (como la tasa turística) no estén incluidos en el precio y se deban abonar directamente en el hotel",
      "bookingFees": "Tasas de reserva",
      "bookingFeesTooltip": "Tasa en concepto de gastos de gestion",
      "promoDiscount": "Descuento promocional",
      "payAtHotel": "A pagar en el hotel",
      "payAtHotelTooltip": "El pago se efectuará en la moneda del alojamiento (el tipo de cambio puede variar)",
      "payNow": "Ahora solo pagas",
      "total": "TOTAL",
      "freeCancellation": "Cancelación gratuita hasta 24h antes del check-in; después, el hotel puede cobrar el importe íntegro.",
      "paymentSplit": "Ahora solo pagas {nowAmount}, el resto ({hotelAmount}) a pagar en el hotel.",
      "seeDetails": "Ver detalles",
      "taxesInfo": "Es posible que algunas tasas y/o impuestos (como la tasa turística) no estén incluidos en el precio final y se deban abonar directamente en el hotel"
    },
    "paymentDetails": {
      "title": "Detalles del pago y cancelación",
      "paymentCharges": {
        "title": "Pago y cobros",
        "item1": "El cargo que verás en tu cuenta será: \"Travel Payment\".",
        "item2": "Solo estás pagando una parte ahora (gastos de gestión) y el resto del importe se paga directamente en el hotel.",
        "item3": "Estás pagando el importe total del alojamiento por adelantado."
      },
      "cancellations": {
        "title": "Cancelaciones y no-shows",
        "item1": "Si reservas con menos de 24h de margen, no será posible cancelar.",
        "item2": "Si cancelas dentro de plazo, te reembolsaremos el importe pagado.",
        "item3": "El hotel se reserva el derecho de cobrar el 100% del importe si no te presentas o cancelas fuera de plazo."
      },
      "checkIn": {
        "title": "Check-in",
        "idRequired": "Presentar un documento de identificación válido (DNI o pasaporte) es obligatorio para todas las personas que se hospeden."
      },
      "support": {
        "title": "Atención al cliente",
        "scheduleMondayThursday": "Lunes a Jueves de 9h a 24:00h (UTC/GMT +1)",
        "scheduleFriday": "Viernes de 9h a 21:00h (UTC/GMT +1)",
        "scheduleWeekend": "Sábados, domingos y festivos de 9:30h a 18:30h (UTC/GMT +1)",
        "whatsapp": "Puedes contactarnos por",
        "email": "Puedes escribirnos a:",
        "phones": "Teléfonos de contacto",
        "uk": "Reino Unido:",
        "france": "Francia:",
        "mexico": "México:",
        "colombia": "Colombia:",
        "spain": "España:"
      }
    },
    "errors": {
      "title": "Error",
      "firstNameRequired": "El nombre es obligatorio",
      "lastNameRequired": "Los apellidos son obligatorios",
      "emailRequired": "El email es obligatorio",
      "emailInvalid": "El email no es válido",
      "phoneInvalid": "El teléfono solo puede contener números",
      "stripeNotAvailable": "Stripe no está disponible",
      "initializePaymentError": "Error al inicializar el pago",
      "initializePaymentRetry": "No se pudo inicializar el pago. Por favor, intenta de nuevo.",
      "clientSecretError": "No se pudo obtener el client secret",
      "paymentContainerError": "El contenedor de pago no está disponible después de múltiples intentos",
      "bookingInitError": "No se pudo inicializar la reserva",
      "paymentElementsError": "Elementos de pago no inicializados",
      "confirmPaymentError": "Error al confirmar el pago",
      "paymentIntentError": "No se pudo obtener el payment intent",
      "paymentIncompleteError": "El pago no se completó correctamente. Estado: {status}",
      "bookingConfirmError": "Error confirmando la reserva",
      "unexpectedPaymentError": "Error inesperado en el proceso de pago"
    }
  },
  "confirm": {
    "meta": {
      "title": "Pago exitoso",
      "description": "Tu reserva ha sido confirmada"
    },
    "header": {
      "title": "¡Pago exitoso!",
      "subtitle": "Tu reserva ha sido confirmada",
      "reference": "Localizador:"
    },
    "loading": "Verificando pago...",
    "personalData": {
      "title": "Datos personales",
      "name": "Nombre",
      "lastName": "Apellidos",
      "email": "Email",
      "phone": "Teléfono"
    },
    "location": {
      "title": "Ubicación"
    },
    "help": {
      "title": "¿Necesitas ayuda?"
    },
    "buttons": {
      "viewBookings": "Ver mis reservas",
      "searchMore": "Buscar más hoteles"
    }
  },
  "onDemandPage": {
    "title": "¿No encuentras disponibilidad? Lo gestionamos por ti",
    "subtitle": "Cuéntanos qué buscas y nuestro equipo revisa opciones de estancia por horas en tu destino y fechas.",
    "sections": {
      "contact": "Datos de contacto",
      "trip": "Destino y fechas",
      "additional": "Información adicional"
    },
    "fields": {
      "name": "Nombre",
      "email": "Email",
      "destination": "Destino",
      "destinationPlaceholder": "Buscar ciudad",
      "checkinDate": "Fecha de entrada",
      "checkinTime": "Hora de check-in",
      "pack": "Pack horas",
      "summary": "Resumen",
      "attemptedBooking": "¿Qué intentaste reservar?",
      "attemptedPlaceholder": "Hotel, enlace o detalle de la estancia que buscabas"
    },
    "privacy": {
      "checkboxBefore": "Acepto la ",
      "link": "política de privacidad",
      "checkboxAfter": " y el tratamiento de mis datos para gestionar esta solicitud."
    },
    "submit": "Enviar solicitud",
    "backHome": "Volver al inicio",
    "success": {
      "title": "Solicitud recibida",
      "body": "Hemos registrado tu petición. Te contactaremos lo antes posible.",
      "backSearch": "Volver a buscar hoteles"
    },
    "errors": {
      "required": "Este campo es obligatorio",
      "email": "El email no es válido",
      "privacy": "Debes aceptar la política de privacidad",
      "attemptedMax": "Texto demasiado largo",
      "generic": "No se pudo enviar la solicitud. Inténtalo de nuevo.",
      "timeOnTheHour": "Elige una hora en punto",
      "validationToastTitle": "No se puede enviar",
      "checkinPast": "La fecha y hora de entrada deben ser posteriores al momento actual.",
      "roomsRange": "Elige entre 1 y 10 habitaciones"
    }
  },
  "strapi": {
    "hotelPage": {
      "descripcion": "Descripción",
      "ubicacion": "Ubicación",
      "servicios": "Servicios",
      "reserva": "Reserva una habitación",
      "verHabitaciones": "Ver habitaciones",
      "preguntas": "Preguntas frecuentes",
      "info": "Información importante",
      "distance_airport": "Distancia al aeropuerto",
      "shuttle_service": "Shuttle service",
      "shuttle_service_information": "Información shuttle service",
      "taxi_distance": "Distancia en taxi",
      "public_transport": "Transporte público",
      "noRooms": "Se han agotado todas las habitaciones disponibles para este hotel el día seleccionado",
      "noRoomsEmpty": {
        "titulo": "Sin habitaciones para esta fecha",
        "descripcion": "Las habitaciones están completas el día elegido. Elige otra fecha disponible."
      },
      "extraDescription": "Elige los extras para completar tu experiencia BYHOURS",
      "extra": {
        "titulo": "Extras",
        "subtitulo": "Los extras se podrán añadir después de seleccionar la habitación"
      },
      "max_pers": {
        "titulo": "Máximo",
        "subtitulo": "personas"
      },
      "noDispo": {
        "titulo": "Sin disponibilidad en este hotel",
        "subtitulo": "Actualmente sin disponibilidad",
        "descripcionAmigable": "No hay disponibilidad en este hotel por el momento."
      },
      "hotelesCercanos": "Descubre más hoteles cerca"
    },
    "searchPage": {
      "filtroHora": "Hora entrada",
      "resultados": "hoteles por horas en",
      "filtroPack": "Pack",
      "filtroPromo": "Promoción",
      "filtroPrecio": "Precio",
      "filtroEstrella": "Categoría",
      "filtroServicio": "Servicios",
      "resultadosAlternativos": "Hoteles cerca de",
      "resultadosNear": "Otros hoteles cerca de",
      "horasEntrada": "Horas de entrada disponibles",
      "sinHorasEntrada": "No disponible",
      "searchZona": "Buscar en esta zona",
      "sinResultados": {
        "titulo": "Oh no :( No hay hoteles disponibles para tu búsqueda, prueba con otro día, hora o destino.",
        "subtitulo": null
      },
      "sinResultadoFiltro": {
        "titulo": "No hay hoteles con los filtros seleccionados",
        "subtitulo": null
      },
      "sinHoteles": {
        "titulo": "¡Vaya! De las 600 ciudades en las que puedes reservar hoteles por horas, has encontrado una en la que todavía no estamos disponibles.",
        "subtitulo": null
      },
      "onDemand": {
        "titulo": "¿No encuentras lo que buscas?",
        "subtitulo": "¡Lo encontramos en 24hrs!"
      },
      "buscandoFechasCercanas": "Buscando disponibilidad en otras fechas…",
      "disponiblesFechasCercanas": "Disponibles en fechas cercanas en",
      "disponibleEl": "Disponible el",
      "probarOtraFecha": "Probar otra fecha:",
      "chipManana": "Mañana",
      "chipPasadoManana": "Pasado mañana",
      "ordenacion": [
        "Relevancia",
        "Precio (menor a mayor)",
        "Precio (mayor a menor)",
        "Categoría (menor a mayor)",
        "Categoría (mayor a menor)"
      ]
    },
    "homePage": {
      "labelHoteles": "Ver más hoteles en"
    },
    "global": {
      "header": {
        "tituloIdioma": "Idioma",
        "tituloMoneda": "Moneda",
        "tituloDestinos": "Destinos",
        "labelDestinos": "Destinos",
        "labelPartners": "Partners",
        "labelAyuda": "Ayuda",
        "destinos": {
          "madrid": "Madrid",
          "barcelona": "Barcelona",
          "berlin": "Berlín",
          "paris": "París",
          "roma": "Roma",
          "dubai": "Dubái",
          "bogota": "Bogotá",
          "mexico": "Ciudad de México",
          "lima": "Lima",
          "panama": "Ciudad de Panamá"
        },
        "buttonDestinos": {
          "label": "Ver todos los destinos",
          "link": "destinos",
          "url": false
        },
        "buttonFunciona": {
          "label": "¿Cómo funciona?",
          "link": "como-funciona",
          "url": false
        },
        "buttonPartner": {
          "hoteleros": "Hoteleros",
          "agencias": "Agencias"
        },
        "buttonAyuda": {
          "contacto": "Contacto",
          "preguntas": "Preguntas frecuentes"
        }
      },
      "footer": {
        "tituloPrivacidad": "Privacidad",
        "tituloInformacion": "Información",
        "tituloHoteleros": "Hoteleros",
        "subtituloHoteleros": "¡Únete a BYHOURS!",
        "tituloAgencia": "¿Eres agencia?",
        "subtituloAgencia": "¡Únete a BYHOURS!",
        "tituloDestinos": "Algunos destinos",
        "tituloSiguenos": "Síguenos",
        "tituloApp": "Descárgate la app",
        "keywords": {
          "hotelesPorHoras": "Hoteles por horas",
          "hotelDeDia": "Hoteles para pasar el día",
          "habitacionPorHoras": "Habitaciones por horas"
        },
        "privacidadLinks": {
          "acuerdo": "Acuerdo de usuario",
          "privacidad": "Política de privacidad",
          "cookies": "Política de cookies"
        },
        "infoLinks": {
          "ayuda": "Ayuda",
          "contacto": "Contacto",
          "blog": "Blog",
          "unete": "Únete al equipo"
        },
        "destinos": {
          "madrid": "Madrid",
          "barcelona": "Barcelona",
          "berlin": "Berlín",
          "paris": "París",
          "roma": "Roma",
          "dubai": "Dubái",
          "bogota": "Bogotá",
          "mexico": "Ciudad de México",
          "lima": "Lima",
          "panama": "Ciudad de Panamá",
          "zurich": "Zúrich",
          "viena": "Viena",
          "londres": "Londres",
          "milan": "Milán",
          "doha": "Doha",
          "buenosAires": "Buenos Aires",
          "quito": "Quito",
          "santiago": "Santiago de Chile"
        },
        "buttonAgencia": {
          "label": "Acceso al portal"
        },
        "buttonHotelero": {
          "label": "Acceso al portal"
        },
        "redes": {
          "instagram": "Instagram",
          "facebook": "Facebook",
          "x": "X",
          "linkedin": "Linkedin",
          "tiktok": "Tik Tok",
          "youtube": "Youtube"
        },
        "buttonsApp": {
          "appStore": "App Store",
          "googlePlay": "Google Play"
        }
      }
    }
  },
  "hoteliersPage": {
    "breadcrumb": {
      "home": "Home",
      "current": "Para hoteleros"
    },
    "hero": {
      "title": "Convierte las horas vacías de tus habitaciones en ingreso",
      "description": "Vende microestancias en franjas de 3, 6 y 24 horas con las reglas que tú gestiones; franja horaria, disponibilidad y canal propio, sin compromiso de cupo.",
      "cta": "Únete a nuestra red de hoteles",
      "imageAlt": "BYHOURS para hoteleros"
    },
    "whyTitle": "Por qué BYHOURS",
    "features": [
      {
        "title": "Flexibilidad total",
        "description": "Gestiona la plataforma con total flexibilidad: cómo y cuándo ofertar microestancias."
      },
      {
        "title": "Sin cupo mínimo",
        "description": "No exigimos un mínimo de habitaciones asignadas. Abre y cierra disponibilidad cuando decidas."
      },
      {
        "title": "Producto diferenciado",
        "description": "Oferta distinta a la venta noche: sin problemas de disparidad de tarifas en tus canales habituales."
      },
      {
        "title": "Ingresos por habitaciones",
        "description": "Rentabiliza franjas y días en los que la habitación no se vende por noche."
      },
      {
        "title": "Nueva cartera de clientes",
        "description": "Accede a viajeros corporativos, escalas y ocio que reservan por horas."
      },
      {
        "title": "Sin permanencia",
        "description": "Prueba el modelo sin compromisos ni cláusulas de permanencia."
      }
    ],
    "whoWeAre": {
      "title": "¿Quiénes somos?",
      "description": "Líderes en microestancias desde 2012. Cifras acumuladas y red actual: cadenas internacionales e independientes aumentan su RevPAR con BYHOURS en cientos de destinos.",
      "ctaQuestion": "¿Listo para ver cómo encaja en tu hotel?",
      "ctaButton": "Solicitar información"
    },
    "stats": [
      {
        "title": "+15 M€",
        "description": "Generados a nuestros hoteles (acumulado)"
      },
      {
        "title": "+300 K",
        "description": "Reservas de microestancias generadas"
      },
      {
        "title": "+250 K",
        "description": "Clientes satisfechos"
      },
      {
        "title": "24",
        "description": "Mercados en Europa, América Latina y Middle East"
      },
      {
        "title": "+600",
        "description": "Destinos disponibles"
      },
      {
        "title": "+4000",
        "description": "Hoteles partners que ya generan ingresos extra"
      }
    ],
    "video": {
      "title": "BYHOURS para tu hotel",
      "description": "Descubre cómo BYHOURS puede ayudarte a rentabilizar tus habitaciones vacías y aumentar tus ingresos.",
      "iframeTitle": "Vídeo BYHOURS para hoteleros"
    },
    "widget": {
      "title": "Vende por horas desde tu propia web",
      "description": "Con una línea de código tu web incorpora un botón flotante que abre el motor de búsqueda por horas: el visitante reserva microestancias al momento, sin salir del entorno de tu hotel.",
      "pillars": [
        {
          "title": "Integración en minutos",
          "description": "Una puesta en marcha ligera: sin proyectos largos ni cambios en tu web más allá del snippet acordado con tu equipo o proveedor."
        },
        {
          "title": "Reserva por horas a un clic",
          "description": "Tus visitantes ven un botón flotante que abre el buscador de microestancias: eligen franja y completan la reserva desde tu propio sitio."
        },
        {
          "title": "Tú sigues mandando",
          "description": "Precio, disponibilidad y reglas siguen saliendo de tu extranet BYHOURS: el widget solo muestra lo que tú autorizas."
        }
      ],
      "featuresSubtitle": "Características del widget",
      "widgetFeatures": [
        {
          "title": "Colores y textos a tu marca",
          "description": "Ajusta color principal y secundario, redondeo del botón y el mensaje del CTA; el contenido del buscador puede mostrarse en varios idiomas según la configuración."
        },
        {
          "title": "Flotante o integrado en la página",
          "description": "Botón en una esquina de la pantalla o widget incrustado en un bloque concreto de tu web: eliges el modo que mejor encaje con el diseño y la navegación."
        },
        {
          "title": "Reglas distintas en móvil y escritorio",
          "description": "Define posición del botón, offsets y comportamiento por separado para pantalla grande y pequeña, para que no tape contenido clave ni rompa el layout."
        }
      ],
      "cta": "Solicitar integración",
      "figcaption": "El botón flotante abre el buscador de microestancias sin salir del sitio del hotel.",
      "imageAlt": "Ejemplo del widget de reserva por horas integrado en la web de un hotel"
    },
    "examples": {
      "title": "Tres ejemplos de clientes reales",
      "description": "Establecimientos que ya facturan microestancias con BYHOURS. Las cifras son estimaciones orientativas según mercado y política comercial.",
      "benefitLabel": "Beneficio para el hotel",
      "bookingsLabel": "Reservas con BYHOURS",
      "cta": "Quiero unirme a la red",
      "cases": [
        {
          "badge": "Barcelona",
          "title": "Hotel 4 estrellas",
          "description": "Mercado mixto de congresos, cruceros y turismo urbano: las microestancias cubren franjas entre estancias de noche y última hora en zona muy competida.",
          "revenue": "+700k €",
          "bookings": "+14k"
        },
        {
          "badge": "Madrid",
          "title": "Hotel urbano",
          "description": "Hotel sin categoría por estrellas que integra el canal por horas para captar viajeros de paso, teletrabajo y estancias cortas sin competir solo con el BAR noche.",
          "revenue": "+300k €",
          "bookings": "+7k"
        },
        {
          "badge": "Bogotá",
          "title": "Hotel 5 estrellas",
          "description": "Perfil premium en capital andina: negocios, eventos y segmento corporativo que valora packs de horas alineados con agendas ajustadas.",
          "revenue": "+400k €",
          "bookings": "+12k"
        }
      ]
    },
    "testimonialsTitle": "Qué dicen nuestros partners",
    "testimonials": [
      {
        "quote": "La flexibilidad en precio y disponibilidad en última hora nos ayuda a mejorar el ADR en franjas que antes quedaban vacías.",
        "name": "Juan Reyna",
        "role": "Director of Sales & Marketing — Hilton Barcelona",
        "kind": "hilton"
      },
      {
        "quote": "En un mercado donde los clientes son cada vez más eclécticos, contar con una solución como BYHOURS nos permite atraer a un tipo de huésped que no siempre encuentra una oferta que se ajuste a sus necesidades. Además, disponer de una plataforma de uso sencillo, que ofrece todo el control y la flexibilidad necesarios, hace que la generación de ingresos adicionales nunca haya sido tan simple.",
        "name": "Xavier Micó",
        "role": "General Manager — Four Points by Sheraton",
        "kind": "marriott"
      },
      {
        "quote": "La plataforma BYHOURS ofrece una solución innovadora y flexible para que los hoteles maximicen la ocupación de sus habitaciones. Destaca especialmente la posibilidad de ofrecer habitaciones no solo por días completos (24 h), sino también por periodos de 3 o 6 horas. Esto abre nuevas oportunidades para reducir vacíos y generar ingresos adicionales.\n\nLa extranet también resulta muy sólida: es clara, está diseñada de forma intuitiva y permite gestionar los listados de manera sencilla y eficiente. Sin un largo periodo de formación, te orientas rápido y usas las funciones principales sin problemas.\n\nOtro punto fuerte es la atención al cliente: las consultas se gestionan con rapidez y siempre con un trato cercano y profesional. Te sientes bien atendido y acompañado, lo que hace muy agradable trabajar con ellos. En conjunto, BYHOURS es una plataforma moderna y bien resuelta que convence por su funcionalidad y por un servicio excelente.",
        "name": "Robert Franke",
        "role": "Channelmanagement Coordinator — GHC Hotels",
        "kind": "ghc"
      },
      {
        "quote": "BYHOURS se ha convertido en una herramienta esencial para nuestra operación diaria. Ofrece máxima flexibilidad en la gestión de disponibilidad, tarifas, creación de paquetes personalizados y un control total de la estrategia comercial, lo que permite una adaptación inmediata a las fluctuaciones del mercado, cancelaciones, salidas anticipadas, etc.\n\nEl impacto en el revenue ha sido muy positivo: hemos conseguido un aumento significativo de los ingresos. Su interfaz intuitiva, su total flexibilidad y la excepcional atención al cliente facilitan enormemente los procesos, reduciendo el tiempo de gestión y minimizando errores operativos.\n\nActualmente es un complemento imprescindible para nuestro hotel.",
        "name": "Anónimo",
        "role": "Socio hotelero",
        "kind": "anonymous"
      }
    ],
    "demand": {
      "title": "Tu hotel llega a estos perfiles de demanda",
      "description": "Así reservan por horas quienes buscan tu hotel: cubrir estos segmentos amplía ocupación e ingresos más allá del patrón noche entera.",
      "items": [
        {
          "title": "Negocios y trabajo",
          "paragraph": "Profesionales que necesitan oficina con wifi, descanso entre reuniones o privacidad fuera de la oficina. Reservan franjas diurnas que encajan con tu inventario entre estancias de noche."
        },
        {
          "title": "Viajeros",
          "paragraph": "Pasajeros con vuelos en conexión, retrasos o largas esperas: buscan ducha, descanso y comodidad cerca del aeropuerto o estación. Tu hotel cubre una necesidad que la noche entera no siempre resuelve."
        },
        {
          "title": "Estilo de vida y ocio",
          "paragraph": "Uso de spa, piscina o terraza antes o después de conciertos, compras o fines de semana urbanos. Captas demanda de ocio que prefiere pagar solo las horas que usa."
        }
      ]
    },
    "steps": {
      "title": "¿Cómo ser parte de BYHOURS?",
      "description": "Generar ingresos con BYHOURS es muy simple. En solo tres pasos ya estarás rentabilizando tus habitaciones vacías.",
      "items": [
        {
          "title": "Registro",
          "description": "Rellena el formulario y nos pondremos en contacto contigo.",
          "linkToForm": true
        },
        {
          "title": "Formación",
          "description": "En una formación sencilla harás la primera carga de disponibilidad y aprenderás a usar la plataforma.",
          "linkToForm": false
        },
        {
          "title": "Venta",
          "description": "Tu hotel está online: ya puedes vender y rentabilizar tus habitaciones vacías con BYHOURS.",
          "linkToForm": false
        }
      ]
    },
    "form": {
      "title": "Únete a nuestra red de hoteles",
      "description": "Envía tu solicitud y te contactaremos lo antes posible para conocer tu hotel y los siguientes pasos. La información solo se usa para responder a tu consulta; responsable del tratamiento: BYHOURS Travel S.L.",
      "successTitle": "Solicitud enviada",
      "successDescription": "Gracias. Hemos recibido tu mensaje y te contactaremos lo antes posible.",
      "hotelSection": "Datos del hotel",
      "contactSection": "Contacto",
      "hotelName": "Nombre del hotel",
      "website": "Sitio web (opcional)",
      "rooms": "Número de habitaciones",
      "roomsPlaceholder": "Selecciona un rango…",
      "cityCountry": "Ubicación del hotel",
      "cityPlaceholder": "Busca ciudad…",
      "contactName": "Nombre de contacto",
      "email": "Email",
      "phone": "Teléfono",
      "comments": "Comentarios (opcional)",
      "commentsPlaceholder": "Cuéntanos qué necesitas: trabajar con nosotros, integración del widget, dudas comerciales…",
      "privacyBefore": "Acepto la ",
      "privacyLink": "política de privacidad",
      "privacyAfter": " y el tratamiento de mis datos para responder a esta solicitud.",
      "submit": "Enviar solicitud",
      "websitePlaceholder": "https://hotel.ejemplo.com"
    },
    "faq": {
      "title": "¿Tienes dudas?",
      "description": "Respuestas a lo que suelen preguntar revenue managers y equipos comerciales.",
      "items": [
        {
          "label": "¿Qué es una microestancia?",
          "content": "Es una reserva de hotel por 3, 6 o 24 horas en la que el cliente elige la hora de entrada dentro de las 24 h del día. Tú controlas precio y disponibilidad por franja."
        },
        {
          "label": "¿Hay compromiso de cupo o permanencia?",
          "content": "No exigimos un mínimo de habitaciones ni permanencia. Puedes probar el modelo y ajustar la oferta cuando lo necesites."
        },
        {
          "label": "¿Afecta a la tarifa BAR o al yield?",
          "content": "El producto está pensado como una línea diferenciada para captar segmentos distintos (negocio, escalas, última hora), ayudando a llenar huecos sin sustituir tu venta noche."
        },
        {
          "label": "¿Cómo se fija el precio por franja?",
          "content": "Tú defines las tarifas y reglas de venta por microestancia desde la extranet, con la flexibilidad que necesite tu estrategia. El equipo te acompaña en la configuración inicial."
        },
        {
          "label": "¿Hay comisiones o modelo de reparto?",
          "content": "Las condiciones comerciales (comisiones, liquidaciones) se acuerdan en la incorporación al partner program. Te las detallamos en la primera conversación tras tu solicitud."
        },
        {
          "label": "¿Se integra con mi PMS o channel manager?",
          "content": "Evaluamos integraciones según tu stack. Cuéntanos qué sistema usas en el formulario o en la llamada de bienvenida y vemos la mejor opción."
        },
        {
          "label": "¿Cómo es la facturación hacia el huésped y el hotel?",
          "content": "BYHOURS gestiona el cobro al huésped según el flujo acordado en tu contrato de partner; te explicamos facturación y liquidaciones en el onboarding."
        },
        {
          "label": "¿Qué necesito para empezar?",
          "content": "Rellena el formulario de esta página. El equipo te guía en la configuración y en la primera publicación de disponibilidad en la extranet."
        }
      ]
    },
    "toast": {
      "validationTitle": "Revisa el formulario"
    },
    "errors": {
      "server": "No se ha podido enviar. Inténtalo de nuevo."
    },
    "validation": {
      "hotelName": "Indica el nombre del hotel",
      "websiteMax": "Web demasiado larga",
      "rooms": "Selecciona un rango de habitaciones",
      "cityCountry": "Indica ciudad y país",
      "contactName": "Indica el nombre de contacto",
      "emailRequired": "Indica el email",
      "emailInvalid": "Email no válido",
      "phone": "Indica un teléfono",
      "commentsMax": "Máximo 4000 caracteres",
      "privacy": "Debes aceptar la política de privacidad"
    },
    "roomRanges": [
      {
        "label": "1 – 9",
        "value": "1-9"
      },
      {
        "label": "10 – 19",
        "value": "10-19"
      },
      {
        "label": "20 – 59",
        "value": "20-59"
      },
      {
        "label": "60 – 99",
        "value": "60-99"
      },
      {
        "label": "100 o más",
        "value": "100+"
      }
    ]
  }
}
